import { GooglePayment } from 'braintree-web';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    trackGooglePayCanceled,
    trackOrderSubmit,
} from '../../../actions/eventAnalytics';
import {
    payWithGooglePayInAndroidApp,
    payWithGooglePayInWeb,
    setHasErrorInGooglePay,
} from '../../../actions/googlePay';
import { PaymentMethodType } from '../../../models/paymentMethods/enums';
import {
    getGooglePayEnvironment,
    getLocaleProps,
} from '../../../selectors/app';
import {
    getGooglePayInstance,
    getGooglePayPaymentRequest,
} from '../../../selectors/googlePay';
import { CheckoutState } from '../../../state';
import { isAndroidApp } from '../../../utils/browser';

const mapStateToProps = (state: CheckoutState) => ({
    environment: getGooglePayEnvironment(state),
    instance: getGooglePayInstance(state),
    isAndroidApp: isAndroidApp(state),
    paymentRequest: getGooglePayPaymentRequest(state),
    ...getLocaleProps(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<CheckoutState>) => ({
    clearError: () => dispatch(setHasErrorInGooglePay(false)),
    handleOnCancel: () => {
        dispatch(trackGooglePayCanceled());
    },
    handleOnClick: (isAndroidApp: boolean) => {
        dispatch(setHasErrorInGooglePay(false));
        dispatch(trackOrderSubmit(PaymentMethodType.GOOGLE_PAY, false));
        if (isAndroidApp) {
            dispatch(payWithGooglePayInAndroidApp());
        }
    },
    handleOnError: () => dispatch(setHasErrorInGooglePay(true)),
    handleOnLoadPaymentData: async (
        paymentData: google.payments.api.PaymentData,
        instance: GooglePayment,
    ) => {
        dispatch(payWithGooglePayInWeb(paymentData, instance));
    },
});

export const connectGooglePayButton = connect(
    mapStateToProps,
    mapDispatchToProps,
);
